/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Ec2InstanceDeletionInfo { 
    instance_name?: string;
    instance_id?: string;
    instance_state?: string;
    region_id?: string;
    is_terminated?: boolean;
    deleteError?: string;
}

